import { render, staticRenderFns } from "./StudentHeaderNavigation.vue?vue&type=template&id=68ea9c37&"
import script from "./StudentHeaderNavigation.vue?vue&type=script&lang=ts&"
export * from "./StudentHeaderNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports